import { FC } from 'react';
import { clsx } from 'clsx';

import { IDateHeaderProps } from '../models/types';

import styles from './styles.module.scss';

export const DateHeader: FC<IDateHeaderProps> = ({ isScrolled }) => {
  return (
    <div
      className={clsx(styles['calendar-schedule__date-header'], {
        [styles['calendar-schedule__date-header_scrolled']]: isScrolled,
      })}
    >
      <div
        className={clsx(styles['calendar-schedule__date-container'], {
          [styles['calendar-schedule__date-container_scrolled']]: isScrolled,
        })}
      >
        <div
          className={clsx(styles['calendar-schedule__date-card'], {
            [styles['calendar-schedule__date-card_scrolled']]: isScrolled,
          })}
        >
          Пн
        </div>
        <div
          className={clsx(styles['calendar-schedule__date-card'], {
            [styles['calendar-schedule__date-card_scrolled']]: isScrolled,
          })}
        >
          Вт
        </div>
        <div
          className={clsx(styles['calendar-schedule__date-card'], {
            [styles['calendar-schedule__date-card_scrolled']]: isScrolled,
          })}
        >
          Ср
        </div>
        <div
          className={clsx(styles['calendar-schedule__date-card'], {
            [styles['calendar-schedule__date-card_scrolled']]: isScrolled,
          })}
        >
          Чт
        </div>
        <div
          className={clsx(styles['calendar-schedule__date-card'], {
            [styles['calendar-schedule__date-card_scrolled']]: isScrolled,
          })}
        >
          Пт
        </div>
        <div
          className={clsx(styles['calendar-schedule__date-card'], {
            [styles['calendar-schedule__date-card_scrolled']]: isScrolled,
          })}
        >
          Сб
        </div>
        <div
          className={clsx(styles['calendar-schedule__date-card'], {
            [styles['calendar-schedule__date-card_scrolled']]: isScrolled,
          })}
        >
          Вс
        </div>
      </div>
    </div>
  );
};
